export const REQUEST_WARNING: string =
  'Для выбранного обучающегося не создано не одного запроса. Создайте новый запрос нажав на плюс ниже или в меню — новый запрос. Для включения ребёнка в программу наставничества, пожалуйста, подтвердите его данные в учреждении доп. образования.';



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/consts.ts